import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MOBILE_NOTIFICATIONS_CONFIG = createFcmDetails('mobile_notifications_config', {
	owner: 'Mobile',
	context: 'Mobile Service',
	description: `
		Configuration for customizing the behaviour of the mobile service's handling of notifications.

		Currently used to configure the number of days that old notifications should be stored in the database before being deleted.
	`,
	template: {
		delete_notifications_older_than_days: 60,
	},
	import: false,
});
